import { defineComponent, inject, onMounted, ref, type SetupContext } from "vue";
import html_iway from "./template.iway.html?raw";
import { infoApiKey, type SenderDto } from "../../../infrastructure/gfo_api/info_api";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

interface Props {
  info_category_uid: string;
}

export default defineComponent({
  template: html,
  props: {
    info_category_uid: {
      type: String,
      required: true,
    },
  },
  setup(props: Props, _context: SetupContext) {
    const infoApi = inject(infoApiKey);
    const senders = ref<SenderDto[]>([]);

    onMounted(async () => {
      const res = await infoApi?.getSender(props.info_category_uid);
      if (typeof res !== "undefined") {
        senders.value = res;
      }
    });

    return {
      senders,
    };
  },
} as any);
